import { render, staticRenderFns } from "./completeGrid.vue?vue&type=template&id=15b1f6c2&scoped=true&"
import script from "./completeGrid.vue?vue&type=script&lang=js&"
export * from "./completeGrid.vue?vue&type=script&lang=js&"
import style0 from "./completeGrid.vue?vue&type=style&index=0&id=15b1f6c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b1f6c2",
  null
  
)

export default component.exports